module.exports = __webpack_public_path__ + "static/media/twitter.98fd26e3.svg";